// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n3-0";
export var assigneeDetails = "_n3-1";
export var assigneeInfo = "_n3-2";
export var dropdownContainer = "_n3-4";
export var dropdownImage = "_n3-5";
export var editAssigneeInfo = "_n3-3";
export var editAssigneeModalContainer = "_n3-6";
export var hidden = "_n3-8";
export var input = "_n3-7";